import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { ArticleImageTile } from "@/components/stock/article-image-tile";

/** Props Interface */
interface ArticleImagePopoverProps {
	articleId: string;
	articleName: string;
}

export function ArticleImagePopover({ articleId, articleName }: ArticleImagePopoverProps) {
	/** Render */
	return (
		<ContentCard
			title={articleName}
			icon={icon("Image")}
		>
			<ArticleImageTile
				articleId={articleId}
				alt={articleName}
			/>
		</ContentCard>
	);
}
